import React from "react";

export function Card({ className = "", children }) {
  return (
    <section className={`rounded-2xl border border-zinc-300/90 bg-white shadow-[0_16px_36px_-24px_rgba(0,0,0,0.45)] ${className}`}>
      {children}
    </section>
  );
}

export function CardHeader({ className = "", children }) {
  return <div className={`border-b border-zinc-200 px-6 py-4 ${className}`}>{children}</div>;
}

export function CardBody({ className = "", children }) {
  return <div className={`px-6 py-5 ${className}`}>{children}</div>;
}

export function CardFooter({ className = "", children }) {
  return <div className={`border-t border-zinc-200 px-6 py-4 ${className}`}>{children}</div>;
}
